import React from 'react'

import MenuItem from './item'

import SpinnerLoader from '../../styled-base/skeleton-loader/implementations/spinner-loader.component'

export default function MenuLoader ({
  isLoading
}) {
  return (
    <MenuItem style={{ height: 20 }}>
      <SpinnerLoader isLoading={isLoading} withBackdrop={false}/>
    </MenuItem>
  )
}